import algoliasearch from 'algoliasearch';
import Slider from './modules/slider'

/* Offer template */
export const Offer = ({url, img_url, title, category, region}) => `
    <a href='${url}' class='card card-offers card-shadow'>
        <div class='card-img-top'>
            <img src='${img_url}' alt='${title}' class='mw-100 mh-100'/>
        </div>
        <div class='card-body'>
            <div class='card-category'>${category}</div>
            <div class='card-title'>${title}</div>
        </div>
        <div class='card-footer'>${region}</div>
    </a>`;


document.addEventListener("turbolinks:load", () => {

  /* ALGOLIA VARIABLES */
  let $algolia = $("#algolia");
  const client = algoliasearch($algolia.data("algolia-id"), $algolia.data("algolia-key"));
  const index = client.initIndex($algolia.data("algolia-index"));

  $algolia.remove();

  /* SELECTION SEARCH */
  $.ajax({
    url: '/.marketplace/api/v1/spotlights/276',
    beforeSend: function (xhr) {
    }, success: function (data) {
      index.search('', {filters: data.filter}).then(({hits}) => {
        buildOffers(hits, '#selection-slider');

        let offerSelectionSlider = new Slider(
          '#offer-selection .slider-offers',
          '.card-deck',
          '#offer-selection',
          500, 1, false);

        offerSelectionSlider.scrollEvent();
      });
    }
  })

  /* NEW SEARCH */
  $.ajax({
    url: '/.marketplace/api/v1/spotlights/277',
    beforeSend: function (xhr) {
    }, success: function (data) {
      index.search('', {filters: data.filter}).then(({hits}) => {
        buildOffers(hits, '#new-slider');

        /* News and Most Viewed Slider are hidden in a bootstrap tab by default, need render to calculate width */
        $('#offer-news').css({visibility: 'hidden', display: 'block'});
        let offerNewsSlider = new Slider(
          '#offer-news .slider-offers',
          '.card-deck',
          '#offer-news',
          500, 1, false);
        $('#offer-news').css({visibility: '', display: ''});
        offerNewsSlider.scrollEvent();

      });
    }
  })

  /* MOST-VIEWED SEARCH */
  $.ajax({
    url: '/.marketplace/api/v1/spotlights/278',
    beforeSend: function (xhr) {
    }, success: function (data) {
      index.search('', {filters: data.filter}).then(({hits}) => {
        buildOffers(hits, '#most-viewed-slider');

        $('#offer-most-viewed').css({visibility: 'hidden', display: 'block'});
        let offerMostViewedSlider = new Slider(
          '#offer-most-viewed .slider-offers',
          '.card-deck',
          '#offer-most-viewed',
          500, 1, false);
        $('#offer-most-viewed').css({visibility: '', display: ''});

        offerMostViewedSlider.scrollEvent();
      });
    }
  })

  function buildOffers(hits, container) {
    let wrapper = $(container);
    let card_deck = null;
    for (let i = 0; i < 18; i++) {
      if (i % 6 === 0) {
        card_deck = $('<div class="card-deck">').appendTo(wrapper)
      }
      card_deck.append(Offer(sanitizeHit(hits[i])));

      if ((i + 1) % 2 === 0) {
        card_deck.append("<div class='w-100 d-block d-md-none'></div>")
      }
      if ((i + 1) % 3 === 0) {
        card_deck.append("<div class='w-100 d-none d-md-block'></div>")
      }
    }
  };

  function sanitizeHit(hit) {
    return {
      url: '/.marketplace/produit/' + hit.id,
      img_url: hit.best_offer.assigned_images[0] && hit.best_offer.assigned_images[0].image_path
        ? hit.best_offer.assigned_images[0].image_path
        : hit.best_offer.default_image
          ? hit.best_offer.default_image
          : '/assets/news_placeholder_480x315.png',
      title: hit.best_offer.name,
      category: hit.application_categories_dict[0] && hit.application_categories_dict[0].name
        ? hit.application_categories_dict[0] && hit.application_categories_dict[0].name
        : '',
      region: hit.best_offer.attributes && hit.best_offer.attributes.comiteo_region
      && hit.best_offer.attributes.comiteo_region[0] && hit.best_offer.attributes.comiteo_region.length === 1
        ? hit.best_offer.attributes.comiteo_region[0]
        : ''
    }
  };

});
